import React from "react";
import { motion } from "framer-motion/dist/framer-motion";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const item = {
  hidden: { scale: 1 },
  show: { scale: [1, 0.7, 1], opacity: [1, 0.7, 1] }
};

const transition = {
  duration: 0.6,
  repeatDelay: 0,
  repeat: Infinity,
  ease: "easeInOut"
};

const Loader = ({ loading }) => {
  return (
    <motion.div
      className={`loading-bubbles-container ${loading ? "visible" : "hidden"}`}
      variants={container}
      initial="hidden"
      animate="show"
    >
      <motion.div className="loader" variants={item} transition={transition} />
      <motion.div className="loader" variants={item} transition={transition} />
      <motion.div className="loader" variants={item} transition={transition} />
    </motion.div>
  );
};

export default Loader;
